import { all } from 'redux-saga/effects';

import organisationSaga from './organisation-saga';

export default function* rootSaga() {
  yield all([organisationSaga()]);
}
